// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6LOm-","textarea":"styles_textarea__3CN9t"};